import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "fileName", "uploadPlaceholder", "filePreview", "uploadContainer", "destroyFlag", "attachmentId"]

  connect() {
    this.updateDisplay()

    // Add event listener to the input field to handle file changes
    this.inputTarget.addEventListener('change', () => {
      // If file input has a file and we have a destroy flag, make sure it's not set
      if (this.inputTarget.files.length > 0 && this.hasDestroyFlagTarget) {
        this.destroyFlagTarget.value = "0"
      }
    })
  }

  updateDisplay() {
    const file = this.inputTarget.files[0]

    if (file) {
      this.fileNameTarget.textContent = file.name
      this.uploadPlaceholderTarget.classList.add("hidden")
      this.filePreviewTarget.classList.remove("hidden")
    } else {
      this.uploadPlaceholderTarget.classList.remove("hidden")
      this.filePreviewTarget.classList.add("hidden")
    }
  }

  fileChanged() {
    this.updateDisplay()

    // If there's a destroy flag and a new file is selected,
    // reset the destroy flag to 0 since we're adding a new file
    if (this.hasDestroyFlagTarget) {
      this.destroyFlagTarget.value = "0"
    }
  }

  dragOver(event) {
    event.preventDefault()
    this.element.classList.add("active")
  }

  dragLeave(event) {
    event.preventDefault()
    this.element.classList.remove("active")
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("active")
  }

  removeAttachment(event) {
    event.preventDefault()

    // Find the closest element with attachment-container class
    const attachmentContainer = event.target.closest(".attachment-container")

    if (attachmentContainer) {
      // Find the destroy flag input and set it to 1 (true) to mark for deletion
      const destroyFlag = this.element.querySelector('[data-file-upload-target="destroyFlag"]')
      if (destroyFlag) {
        destroyFlag.value = "1"
      }

      // Hide the attachment display but don't remove it from DOM
      // so the destroy flag remains in the form
      attachmentContainer.style.display = "none"

      // Show the upload container to allow new file upload
      if (this.hasUploadContainerTarget) {
        this.uploadContainerTarget.classList.remove("hidden")
      }

      // Clear the file input to ensure consistency
      if (this.inputTarget) {
        this.inputTarget.value = ""
      }
    }
  }
}
